'use strict'

const BlueInfoBanner =  {
    elt : null,
    init: function(){
        BlueInfoBanner.elt = document.querySelector('.f-blueInfoBanner');
        if(BlueInfoBanner.elt) {
            BlueInfoBanner.elt.querySelector('.f-blueInfoBanner__close').addEventListener("click", () => {
                BlueInfoBanner.elt.classList.add('hide--');
            });
        }
    }
}

export default BlueInfoBanner;